import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  verifyCodeSuccessMsg: null,
  verifyCodeError: null,
  loading: false,
};

const verifyCodeSlice = createSlice({
  name: "verifyCode",
  initialState,
  reducers: {
    verifyCodeSuccess(state, action) {
      state.verifyCodeSuccessMsg = action.payload;
    },
    verifyCodeError(state, action) {
      state.verifyCodeError = action.payload;
    },
    loadingData(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { verifyCodeSuccess, verifyCodeError, loadingData } = verifyCodeSlice.actions;

export default verifyCodeSlice.reducer;
